import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      <footer id="footer" className="footer dark-background">
        <div className="container">
          <div className="row gy-3">
            <div className="col-lg-3 col-md-6 d-flex">
              <div className="footer-info footer-text">
                <div className="mb-4">
                  <img src="/assets/img/mewar-logo.png" width="220px" alt="Mewar University" />
                </div>
                <p className="mb-4 fs-12">
                  Quality education with flexible learning—designed to empower working professionals.
                </p>
                <p className="fs-12 position-relative">
                  Mewar University is recognized by the UGC under sections 2(f) and 22(1) of the UGC Act, 1956, 
                  and is the only private, self-financed university in Rajasthan approved under section 12B. 
                  The university is also accredited with NAAC 'A' grade.
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 d-flex">
              <i className="bi bi-box-arrow-up-right icon"></i>
              <div className="footer-list">
                <h4>Quick Links</h4>
                <ul className="list-unstyled d-flex flex-column gap-2 fs-14">
                  <li>
                    <Link to="/btech-civil-engineering" className="text-decoration-none text-light text-light-50">
                      <i className="bi bi-chevron-double-right"></i> Civil Engineering
                    </Link>
                  </li>
                  <li>
                    <Link to="/btech-electrical-engineering" className="text-light text-decoration-none">
                      <i className="bi bi-chevron-double-right"></i> Electrical Engineering
                    </Link>
                  </li>
                  <li>
                    <Link to="/btech-mechanical-engineering" className="text-light text-decoration-none">
                      <i className="bi bi-chevron-double-right"></i> Mechanical Engineering
                    </Link>
                  </li>
                  <li>
                    <Link to="/btech-computer-science-engineering" className="text-light text-decoration-none">
                      <i className="bi bi-chevron-double-right"></i> Computer Engineering
                    </Link>
                  </li>
                  <li>
                    <Link to="/btech-electronic-and-communication-engneering" className="text-light text-decoration-none">
                      <i className="bi bi-chevron-double-right"></i> Electronic & Communication
                    </Link>
                  </li>
                  <li>
                    <Link to="/btech-chemical-engneering" className="text-light text-decoration-none">
                      <i className="bi bi-chevron-double-right"></i> Chemical Engineering
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 d-flex">
              <i className="bi bi-box-arrow-up-right icon"></i>
              <div className="footer-list">
                <h4>Important Links</h4>
                <ul className="list-unstyled d-flex flex-column gap-2 fs-14">
                  <li>
                    <Link to="/privacy-policy-and-disclaimer" className="text-decoration-none text-light text-light-50">
                      <i className="bi bi-chevron-double-right"></i> Privacy Policy
                    </Link>
                  </li>
                  <li>
                    <Link to="/contact-us" className="text-decoration-none text-light text-light-50">
                      <i className="bi bi-chevron-double-right"></i> Contact Us
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="d-flex footer-text">
                <i className="bi bi-geo-alt icon"></i>
                <div>
                  <h4>Address</h4>
                  <p>
                    NH - 48 Gangrar <br />
                    Chittorgarh, Rajasthan - 312901
                  </p>
                </div>
              </div>

              <div className="d-flex footer-text">
                <i className="bi bi-telephone icon"></i>
                <div>
                  <h4>Contact Us</h4>
                  <p>
                    <strong>Phone:</strong> <span>+91 869 295 6126</span><br />
                    <strong>Email:</strong> <span>info@distanceengineering.org</span><br />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container copyright text-center mt-4">
          <p>
            © <span>Copyright</span> <strong className="px-1 sitename">Mewar University</strong> <span>All Rights Reserved</span>
          </p>
        </div>
      </footer>

      {/* Scroll Top */}
      <a 
        href="#top" 
        id="scroll-top" 
        className="scroll-top d-flex align-items-center justify-content-center"
        onClick={(e) => {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }}
      >
        <i className="bi bi-arrow-up-short"></i>
      </a>

      {/* Sticky Footer Mobile */}
      <div className="footerStickyMobile position-fixed bottom-0 start-0 w-100 align-items-center overflow-hidden bg-white d-lg-none d-flex">
        <button 
          onClick={() => {
            window.dispatchEvent(new CustomEvent('showApplicationModal'));
          }}
          className="d-flex justify-content-center align-items-center btn-animated btn btn-warning fw-600 position-relative rounded-0 w-50 py-2 border-0"
          style={{ transition: 'all .3s ease-in-out' }}
        >
          <i className="bi bi-telephone-fill position-relative px-1"></i>
          Apply Now
        </button>
        {/* https://wa.link/500mib  */}
        <a 
          href="https://wa.link/ol61oa" 
          target="_blank" 
          rel="noopener noreferrer"
          className="d-flex justify-content-center align-items-center w-50 text-center text-white text-decoration-none py-2 fw-600"
          style={{ background: '#00b66c', cursor: 'pointer' }}
        >
          <i className="bi bi-whatsapp position-relative graduation-icon me-1" style={{ fontSize: '19px' }}></i>
          Chat With Us
        </a>
      </div>
    </>
  );
};

export default Footer;
